module.exports = __webpack_public_path__ + "img/report.4218d052.svg";